/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UserOrderTimerFromJSON(json) {
    return UserOrderTimerFromJSONTyped(json, false);
}
export function UserOrderTimerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'timerStarted': !exists(json, 'timerStarted') ? undefined : (json['timerStarted'] === null ? null : new Date(json['timerStarted'])),
    };
}
export function UserOrderTimerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'userId': value.userId,
        'timerStarted': value.timerStarted === undefined ? undefined : (value.timerStarted === null ? null : value.timerStarted.toISOString()),
    };
}
